(() => {
  const script = document.currentScript;
  const pageType = script?.dataset.pageType || '';
  const attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  let attribution = {};

  try {
    attribution = JSON.parse(sessionStorage.getItem('solid8_attribution') || '{}');
    const landingParams = new URLSearchParams(window.location.search);
    const currentAttribution = {};

    attributionKeys.forEach((key) => {
      const value = landingParams.get(key);
      if (value) currentAttribution[key] = value;
    });

    if (Object.keys(currentAttribution).length) {
      attribution = currentAttribution;
      sessionStorage.setItem('solid8_attribution', JSON.stringify(attribution));
    }
  } catch (error) {
    attribution = {};
  }

  const publishCroEvent = (eventName, detail = {}) => {
    if (!eventName) return;

    if (typeof window.clarity === 'function') {
      window.clarity('event', eventName);
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      page_type: pageType,
      page_path: window.location.pathname,
      ...attribution,
      ...detail,
    });
  };

  window.solid8PublishCroEvent = publishCroEvent;

  const impressionTargets = document.querySelectorAll('[data-cro-impression]');
  if ('IntersectionObserver' in window) {
    const impressionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;

          const target = entry.target;
          if (target.dataset.croImpressionSent === 'true') return;

          target.dataset.croImpressionSent = 'true';
          publishCroEvent(target.dataset.croImpression, {
            placement: target.dataset.croPlacement || '',
            product_handle: target.dataset.productHandle || '',
            article_handle: target.dataset.articleHandle || '',
          });
          impressionObserver.unobserve(target);
        });
      },
      { threshold: 0.5 },
    );

    impressionTargets.forEach((target) => impressionObserver.observe(target));
  }

  document.querySelectorAll('.s8-native-form').forEach((form) => {
    const section = form.closest('[data-s8-product]');
    const details = () => ({
      product_handle: section?.dataset.productHandle || '',
      variant_id: form.querySelector('[data-s8-variant]:checked')?.value || '',
      selling_plan_id: form.querySelector('[data-s8-options]:not([hidden]) [data-s8-plan]:checked')?.value || '',
      quantity: Number(form.querySelector('[name="quantity"]')?.value || 1),
    });
    form.addEventListener('change', (event) => {
      if (event.target.matches('[data-s8-variant], [data-s8-plan]')) publishCroEvent('product_purchase_option_changed', details());
    });
    form.addEventListener('submit', () => {
      publishCroEvent('product_add_to_cart_submit', details());
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries.some(entry => entry.isIntersecting)) {
          publishCroEvent('product_purchase_options_seen', { product_handle: section?.dataset.productHandle || '' });
          observer.disconnect();
        }
      });
      observer.observe(form.querySelector('.s8-supply') || form);
    }
  });

  document.addEventListener('click', (event) => {
    const scrollAddToCart = event.target.closest('[data-solid8-scroll-atc-button]');
    if (scrollAddToCart) {
      const scrollAddToCartContainer = scrollAddToCart.closest('[data-solid8-scroll-atc]');
      publishCroEvent(scrollAddToCart.dataset.croEvent, {
        placement: `${scrollAddToCartContainer ? scrollAddToCartContainer.dataset.mode : ''}_scroll_30`,
        product_handle: scrollAddToCart.dataset.productHandle || '',
        article_handle: scrollAddToCart.dataset.articleHandle || '',
      });
      return;
    }

    const linkedEvent = event.target.closest('[data-cro-event]');
    if (linkedEvent && event.target.closest('a[href]')) {
      const content = event.target.closest('[data-cro-content]');
      publishCroEvent(linkedEvent.dataset.croEvent, {
        placement: linkedEvent.dataset.croPlacement || '',
        content: content ? content.dataset.croContent : '',
        product_handle: linkedEvent.dataset.productHandle || '',
        article_handle: linkedEvent.dataset.articleHandle || '',
        destination: event.target.closest('a[href]').getAttribute('href') || '',
      });
      return;
    }

    const addToCart = event.target.closest('.product-form__submit');
    if (addToCart) {
      const productInfo = addToCart.closest('product-info');
      const placementTarget = addToCart.closest('[data-cro-placement]');
      publishCroEvent('product_add_to_cart_click', {
        placement: placementTarget ? placementTarget.dataset.croPlacement : 'product_purchase_form',
        product_path: productInfo ? productInfo.dataset.url : window.location.pathname,
      });
    }
  });
})();
